// extracted by mini-css-extract-plugin
export var centerText = "_e8-8";
export var container = "_e8-0";
export var doughnutContainer = "_e8-7";
export var legend = "_e8-a";
export var legendItemColorDisplay = "_e8-b";
export var legendItemLabel = "_e8-d";
export var legendItemValue = "_e8-c";
export var lg = "_e8-5";
export var maxWidth = "_e8-9";
export var md = "_e8-4";
export var responsive = "_e8-6";
export var sm = "_e8-3";
export var xs = "_e8-2";
export var xxs = "_e8-1";